import axios from 'axios'
import store from '../store'
// Request interceptor

axios.defaults.baseURL = process.env.apiUrl

axios.interceptors.request.use(request => {
	const token = store.state.auth.token

	if (token) {
		request.headers.common['Authorization'] = `Bearer ` + token
	}

	return request
})

axios.interceptors.response.use(response => response, error => {
	return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./src/plugins/axios.js